import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { RecipientCriptoService } from '../../services/recipient-cripto.service';
import { TransferenciasUSDT } from '../../interfaces/transferencia-usdt.interface';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-manual-transaction-history-dialog',
  templateUrl: './manual-transaction-history-dialog.component.html',
  styleUrls: ['./manual-transaction-history-dialog.component.sass']
})
export class ManualTransactionHistoryDialogComponent {

  dataSource : MatTableDataSource<any> | undefined;
  transacciones: TransferenciasUSDT[] = [];
  public currentPage = 1;
  public pageSize = 5;
  public totalItems = 0;
  public totalPages = this.totalItems/this.pageSize;

  @ViewChild(MatSort) sort: MatSort = new MatSort();
  @ViewChild(MatPaginator) paginator!: MatPaginator;


  constructor(
    private recipientcriptoservice:RecipientCriptoService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.loadTransactions();
  };

  async loadTransactions(){
    this.transacciones = await this.recipientcriptoservice.getTransactionCriptoManualTransactions(this.data.id);
    this.dataSource = new MatTableDataSource(this.transacciones);
    this.dataSource.paginator = this.paginator;
    this.totalItems = this.transacciones.length;
    this.totalPages = Math.ceil (this.totalItems/this.pageSize);
  }

  displayedColumns: string[] = [
    'idTransferencia', 'fechaInicio', 'fechaFondeoWallet', 'montoCLP',
    'montoUSDT', 'remitente', 'estadoActual', 'tn', 'walletTRC20'
  ];

  getStatusBg(row: any): string {
    const estado = (row.estadoActual || '').toUpperCase();
    if (estado.includes('COMPLETAD') || estado.includes('PAGAD')) return '#dcfce7';
    if (estado.includes('RECHAZAD') || estado.includes('CANCELAD')) return '#fee2e2';
    if (estado.includes('PENDIENTE') || estado.includes('PROCESO')) return '#fef9c3';
    return '#f3f4f6';
  }

  getStatusColor(row: any): string {
    const estado = (row.estadoActual || '').toUpperCase();
    if (estado.includes('COMPLETAD') || estado.includes('PAGAD')) return '#166534';
    if (estado.includes('RECHAZAD') || estado.includes('CANCELAD')) return '#991b1b';
    if (estado.includes('PENDIENTE') || estado.includes('PROCESO')) return '#854d0e';
    return '#374151';
  }

  printHistorial() {
    const headers = [
      "ID",
      "Fecha Inicio",
      "Fecha Fondeo Wallet",
      "Monto CLP",
      "Monto USDT",
      "Remitente",
      "Estado Actual",
      "Tasa",
      "Wallet"
  ];

  const dataToExport = this.transacciones.map(tx => ({
      ID: tx.idTransferencia,
      'Fecha Inicio': this.formatDate(new Date(tx.fechaInicio)),
      'Fecha Fondeo Wallet': this.formatDate(tx.fechaFondeoWallet),
      'Monto CLP': tx.montoCLP,
      'Monto USDT': tx.montoUSDT,
      'Remitente': tx.remitente,
      'Estado Actual': tx.estadoActual.replace(/_/g, ' '),
      'Tasa': tx.tn,
      'Wallet': tx.walletTRC20
  }));

  const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport);

  XLSX.utils.sheet_add_aoa(ws, [headers], { origin: "A1" });

  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Transactions');

  const wbout: ArrayBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  saveAs(new Blob([wbout], { type: 'application/octet-stream' }), this.data.id+'.xlsx');
  }

  formatDate(dateString: Date) {
    const date = new Date(dateString);
    
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

  onPageChange(event: any) {
    this.pageSize=event.pageSize;
    this.currentPage = event.pageIndex+1;
    this.loadTransactions();
  }
  
  filterTransactionsByWallet(transactions: TransferenciasUSDT[], id: string): TransferenciasUSDT[] {
    return transactions.filter(transaction => transaction.walletTRC20 === id);
  }
}